import React from "react";
import { useState, useEffect } from "react";
import {
	Theme,
	Button,
	Typography,
	Divider,
	FormControl,
	InputLabel,
	Select,
	Grid,
	Checkbox,
	InputAdornment,
	OutlinedInput,
	IconButton,
	Dialog,
	DialogContent,
	DialogContentText,
	DialogActions,
	useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { SelectChangeEvent } from "@mui/material/Select";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import PaymentMethods from "../Profile/Payments/PaymentMethods";
import OneTimeCardForm from "../Profile/Dialogs/OneTimePayForm";
import Alert from "@mui/material/Alert";
import CloseIcon from "@mui/icons-material/Close";
import ButtonLoader from "../../utils/ButtonLoader";
import styles from "../../styles";
import { renderPaymentMethods } from "../Forms/PaymentMethods";
import getLegends from "../../helpers/getLegends";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			width: "100%",
			borderRadius: 5,
			padding: 0,
			[theme.breakpoints.up("md")]: {
				minWidth: 600,
			},
		},
		margin: {
			margin: 20,
		},
		padding: {
			paddingLeft: 20,
			paddingRight: 20,
		},
		header: {
			backgroundColor: theme.palette.primary.main,
			color: "white",
			borderTopLeftRadius: 5,
			width: "100%",
			padding: 20,
		},
		table: {
			width: "100%",
			padding: 20,
		},
		color: {
			backgroundColor: theme.palette.primary.main,
			color: "white",
		},
		print: {
			"@media print": {
				display: "none",
			},
			width: "100%",
		},
		invoice: {
			width: "80%",
			"@media print": {
				width: "100%",
				border: "none",
			},
		},
		link: {
			textDecoration: "underline",
			cursor: "pointer",
		},
		red: {
			color: "red",
		},
		fontSize: {
			[theme.breakpoints.down("md")]: {
				fontSize: 14,
			},
		},
		formControl: {
			width: "100%",
			padding: 0,
		},
		chips: {
			display: "flex",
			flexWrap: "wrap",
		},
		chip: {
			margin: 2,
		},
		menuItem: {
			backgroundColor: "#FAFAFA !important",
		},
		alert: {
			width: "100%",
			alignItems: "center",
			justifyContent: "center",
		},
		closeButton: {
			justifyContent: "flex-end",
		},
		promo: {
			width: "100%",
			alignItems: "center",
		},
	})
);

export default function CompletePurchase(props: any) {
	const classes = useStyles();
	const {
		userInfo,
		userConfig,
		billingProfiles,
		getCredits,
		clubData,
		credits,
	} = props;
	const [client, setClient] = useState<string>(clubData?.clubType);
	const [collapse, setCollapse] = useState<boolean>(false);
	const [oneTimePayment, setOneTimePayment] = useState<boolean>(true);
	const [checked, setChecked] = useState<boolean>(false);
	const [paymentMethod, setPaymentMethod] = useState<string>("");
	const [oneTimePaymentType, setOneTimePaymentType] =
		useState<string>("CreditCard");
	const [purchase, setPurchase] = useState<boolean>(false);
	const [open, setOpen] = useState("0");
	const [oneTime, setOneTime] = useState<boolean>(false);
	const [promoCode, setPromoCode] = useState<string>(
		props.promo ? "Promo Applied" : ""
	);
	const [discountStatus, setDiscountStatus] = useState<boolean>(false);
	const [alert, setAlert] = useState<string>("");
	const [values, setValues] = useState<any>({
		amountType: "all",
		credit: props?.credit,
		amount: null,
		paymentMethodType: paymentMethod,
		billingProfileId: null,
		accountNumber: "",
		routing: "",
		accountTypeFull: "",
		creditcard: null,
		nameOnCard: null,
		expiryMonth: null,
		expiryYear: null,
		securityCode: null,
		bankName: "",
		firstName: "firstName",
		lastName: "lastName",
	});
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down("md"));
	useEffect(() => {
		setCollapse(true);
	}, [collapse]);
	const sortedBillingProfiles = [{
		id: "19",
		profileType: "CreditCard",
		isDefaultProfile: true,
		creditCardType: "Visa",
		accountNumber: "411111111111111",
		accountTypeFull: "Credit Card",
		expDateShort: "12/22"

	}]
	const handleSetChecked = (event: any) => {
		setChecked(event.target.checked);
	};
	const setPaymentProfile = () => {
		let isDefault: any = false;
		sortedBillingProfiles?.forEach((profile: any) => {
			if (profile.isDefaultProfile && !oneTime) {
				setPaymentMethod(profile.id);
				isDefault = true;
			} else {
				if (sortedBillingProfiles.length > 0) {
					setPaymentMethod(sortedBillingProfiles[0].id);
				}
			}
		});
	};
	const handleClientChange = (event: SelectChangeEvent) => {
		let value: any = event.target.value;
		setClient(value);
	};
	const checkDefault = (id: any) => {
		let isDefaultProfile: any = false;
		const isDefault: any = billingProfiles.find((x: any) => x.id === id);
		if (isDefault.isDefaultProfile) {
			isDefaultProfile = true;
		}
		return isDefaultProfile;
	};
	const handlePaymentChange = (event: SelectChangeEvent) => {
		setPaymentMethod(event.target.value as string);
	};
	const usePromoCode = () => {
		let config: any = props.config;
		config.promoCode = promoCode;
		if (promoCode?.length > 0) {
			props.applyPromoCode(config);
		}
	};

	const clearAll = () => {
		setAlert("");
	};
	const openAddPayment = () => {
		setOpen("1");
	};
	const handleClose = () => {
		setOpen("0");
	};
	let paymentMethods: any = renderPaymentMethods(
		sortedBillingProfiles,
		oneTimePaymentType,
		values,
		oneTime
	);


	const getTax = () => {
		let tax = props.subtotal * .08
		return tax.toFixed(2);
	};

	let discount = 0
	let tax = getTax();
	let total: any =
		tax + props.subtotal;
	let creditAmount: any;
	if (checked && total < props.credits / 100) {
		creditAmount = total * 100;
	} else {
		creditAmount = credits;
	}
	const completePurchase = (event: any) => {
		event.preventDefault();
		setPurchase(true);
		props.clearCart()
		props.closeCart()
		props.setMessages("Purchase was successfully completed")
		setOpen("0")
	};


	const handleBack = () => {
		props.onClose();
	};

	console.log("cis", props.cartItems)
	return (
		<>
			<Typography variant="h5" align="center" className={classes.header}>
				Complete Purchase
			</Typography>
			<DialogContent>
				<DialogContentText>
					<Grid
						container
						justifyContent="center"
						style={{
							paddingBottom: 10,
							marginBottom: 10,
							borderBottom: "1px solid lightgrey",
						}}
					>
						<Grid item xs={2}>
							<Typography color="secondary" align="left">Quantity</Typography>
						</Grid>
						<Grid item xs={5}>
							<Typography sx={{ pl: 6 }} color="secondary" align="left">Item</Typography>
						</Grid>
						<Grid item xs={5}>
							<Typography color="secondary" align="right">Amount</Typography>
						</Grid>
					</Grid>
					<>
						{props.cartItems.map((item: any, index: any) => (
							<React.Fragment key={index}>
								<Grid
									key={index}
									container
									justifyContent="center"
									style={{ padding: "0px 0px 20px 20px" }}
								>
									<Grid item xs={2}>
										<Typography color="primary.contrastText">{item.quantity}</Typography>
									</Grid>
									<Grid item xs={5}>
										<Typography color="primary.contrastText" align="center">{item.name}</Typography>
									</Grid>
									<Grid item xs={5}>
										<Typography color="primary.contrastText" align="right">
											${item.amount.toFixed(2)}
										</Typography>
									</Grid>
								</Grid>
							</React.Fragment>
						))}
						<Divider color="white" />
						<Grid container justifyContent="flex-end">
							<Grid
								container
								justifyContent="space-between"
								style={{ maxWidth: 250, width: "100%", paddingTop: 10 }}
							>
								<Grid item xs={6}>
									<Typography color="primary.contrastText">Subtotal:</Typography>
								</Grid>
								<Grid item xs={6}>
									<Typography color="primary.contrastText" align="right">
										${props.subtotal.toFixed(2)}
									</Typography>
								</Grid>

								<Grid item xs={6}>
									<Typography color="primary.contrastText">Tax:</Typography>
								</Grid>
								<Grid item xs={6}>
									<Typography color="primary.contrastText" align="right">
										${tax}
									</Typography>
								</Grid>
								<Grid item xs={6}>
									<Typography color="primary.contrastText">Total:</Typography>
								</Grid>
								<Divider color="white" />
								<Grid item xs={6}>

									<Typography color="primary.contrastText" align="right" >
										${(Number(props.subtotal) + Number(tax)).toFixed(2)}
									</Typography>
								</Grid>



							</Grid>
							<Grid container justifyContent="flex-start">
								<Grid item xs={8}>
									<FormControl fullWidth margin="normal" variant="outlined" color="secondary">
										<InputLabel shrink={true} htmlFor="outlined-age-native-simple">
											Payment Method
										</InputLabel>
										<Select
											fullWidth
											color="secondary"
											label="Payment Method"
											native
											value={paymentMethod}
											onChange={handlePaymentChange}
											disabled={
												(checked && client === "FSB ONLY") ||
												(checked && client === "SSB" && credits / 100 > total) ||
												(checked && credits / 100 > total)
											}
											inputProps={{
												name: "paymentMethod",
												id: "outlined-age-native-simple",
												padding: 5,
												style: { color: "white" }
											}}
										>
											{paymentMethods}
										</Select>
									</FormControl>
								</Grid>
								<Grid container >
									<Grid item xs={8}>
										<Button
											fullWidth
											onClick={openAddPayment}
											variant="outlined"
											color="secondary"
										>
											Payment Methods
										</Button>
									</Grid>
								</Grid>
							</Grid>
							<Dialog open={open === "1"} onClose={handleClose} sx={styles.modal}>
								<PaymentMethods
									{...props}
									handleClose={handleClose}
									setIsDefault={props.setIsDefault}
									open={true}
								/>
							</Dialog>
						</Grid>
					</>
				</DialogContentText>
			</DialogContent >
			<DialogActions sx={{ p: 2 }}>
				<Button
					color="secondary"
					onClick={handleBack}
					variant="outlined"
					fullWidth
					sx={{ mr: 1 }}
				>
					Back to Cart
				</Button>

				<Button
					color="secondary"
					variant="contained"
					fullWidth
					onClick={completePurchase}
					sx={{ ml: 1 }}
				>

					Complete Purchase

				</Button>
			</DialogActions>
		</>
	);
}
